import React, { useEffect, useState } from "react";
import _ from "lodash";
import { Button, Form, Modal } from "react-bootstrap";
import AsyncButton from "common/ui/AsyncButton";
import { OfferTypeEnum, getOfferTypeName, toContractType } from "domain/offerType";
import { ContractType } from "domain/contract";

export type OfferContractTypesProps = {
    appendTitle?: string;
    offerTypes: OfferTypeEnum[];
    contractTypes: ContractType[];
    existingOfferTypes: OfferTypeEnum[];
    existingContractTypes: ContractType[];
    showModal: boolean;
    handleSubmit(offerTypes: OfferTypeEnum[], contractTypes: ContractType[]): void;
    handleCancel: () => void;
};

const OfferContractTypesModal: React.FC<OfferContractTypesProps> = (props: OfferContractTypesProps) => {
    const [selectedOfferTypes, setSelectedOfferTypes] = useState<OfferTypeEnum[]>([]);
    const [selectedContractTypes, setSelectedContractTypes] = useState<ContractType[]>([]);
  
    useEffect(() => {
        if(props.existingOfferTypes == null) return;
        setSelectedOfferTypes(props.existingOfferTypes);
        
    }, [props.existingOfferTypes])

    useEffect(() => {
        if(props.existingContractTypes == null) return;
        setSelectedContractTypes(props.existingContractTypes);
        
    }, [props.existingContractTypes])
    
    function selectAll() {
        setSelectedOfferTypes(props.offerTypes.filter(m => ![OfferTypeEnum.BasisContract, OfferTypeEnum.DelayedPriceContract].includes(m)));
        setSelectedContractTypes(props.contractTypes);
    }
    
    function unselectAll() {
        setSelectedOfferTypes([]);
        setSelectedContractTypes([]);
    }

    function isChecked(offerType: OfferTypeEnum) {
        if(selectedOfferTypes.some(ot => ot === offerType))
            return true;
        else if([OfferTypeEnum.BasisContract, OfferTypeEnum.DelayedPriceContract].includes(offerType))
            return selectedContractTypes.some(ct => ct === toContractType(offerType));
        return false;
    }

    function toggle(offerType: OfferTypeEnum, isChecked: boolean) {
        if(isChecked) {
            if(![OfferTypeEnum.FixBasisOnHta, OfferTypeEnum.FixFuturesOnBasis].includes(offerType)){
                setSelectedContractTypes([...selectedContractTypes, toContractType(offerType)]);
            }
            setSelectedOfferTypes([...selectedOfferTypes, offerType]);
        }
        else {
            if(![OfferTypeEnum.FixBasisOnHta, OfferTypeEnum.FixFuturesOnBasis].includes(offerType)){
                setSelectedContractTypes(selectedContractTypes.filter(ct => ct !== toContractType(offerType)));
            }
            setSelectedOfferTypes(selectedOfferTypes.filter(ot => ot !== offerType));
        }
    }

    async function handleSubmit() {
        props.handleSubmit(selectedOfferTypes, selectedContractTypes);
        onClose();
    }

    function onClose() {
        setSelectedOfferTypes([]);
        setSelectedContractTypes([]);
        props.handleCancel();
    }

    function isAllSelected(){
       return selectedOfferTypes.length === props.offerTypes.filter(m => ![OfferTypeEnum.BasisContract, OfferTypeEnum.DelayedPriceContract].includes(m)).length
        && selectedContractTypes.length === props.contractTypes.length;
    }

    return <Modal show={props.showModal} dialogClassName="modal-md" onHide={onClose} backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>Offers/Contracts {props.appendTitle ? ` - ${props.appendTitle}` : ''}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                    {!isAllSelected() && <button className="link-button"
                        onClick={selectAll}>
                        Select All
                    </button>}
                    {isAllSelected() && <button className="link-button"
                        onClick={unselectAll}>
                            Unselect All
                    </button>}

                    {props.offerTypes.map(ot => <Form.Check 
                        key={ot}
                        id={"type-" + ot}
                        checked={isChecked(ot)}
                        onChange={ev => toggle(ot, ev.target.checked)}
                        label={getOfferTypeName(ot)}
                    />)}
            </Modal.Body>
            <Modal.Footer className="align center">
                <Button variant="secondary" onClick={onClose}>
                    Cancel
                </Button>
                <AsyncButton variant="primary" onClickAsync={handleSubmit}>
                    Save
                </AsyncButton>
            </Modal.Footer>
        </Modal>;
}
  

export default OfferContractTypesModal;